export interface ParsedOrderFilename {
	orcId: number;
	oitId: number;
	cliente: string;
	material: string;
	/** Nome do arquivo sem extensão */
	baseName: string;
}

const PREFIX_RE = /^\[O-(\d+)\]_\[I-(\d+)\]_/;
const PTS_RE = /_pts(\d+)_/;

/**
 * Extrai orc_id, oit_id e material de nomes no padrão:
 * [O-{orc}]_[I-{oit}]_{cliente}_{material}_pts{N}_{ctr}
 */
export function parseOrderFromFilename(
	fileName: string,
): ParsedOrderFilename | null {
	if (!fileName?.trim()) return null;

	const baseName = fileName.replace(/\.[^.]+$/, "").trim();
	const prefixMatch = baseName.match(PREFIX_RE);
	if (!prefixMatch) return null;

	const orcId = Number(prefixMatch[1]);
	const oitId = Number(prefixMatch[2]);
	if (!Number.isFinite(orcId) || !Number.isFinite(oitId)) return null;

	const ptsMatch = baseName.match(PTS_RE);
	if (!ptsMatch || ptsMatch.index === undefined) return null;

	const afterPrefix = baseName.slice(prefixMatch[0].length, ptsMatch.index);
	const segments = afterPrefix.split("_").filter(Boolean);
	if (segments.length === 0) return null;

	const material = segments[segments.length - 1] ?? "";
	const cliente = segments.slice(0, -1).join("_");

	return { orcId, oitId, cliente, material, baseName };
}
